var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-May-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cancelation-3",
    transform: "translate(-499.000000, -460.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(469.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(30.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fillOpacity: 0.1,
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,2.4 L20.4,2.4 L20.4,1.2 C20.4,0.48 19.92,0 19.2,0 C18.48,0 18,0.48 18,1.2 L18,2.4 L6,2.4 L6,1.2 C6,0.48 5.52,0 4.8,0 C4.08,0 3.6,0.48 3.6,1.2 L3.6,2.4 L1.2,2.4 C0.6,2.4 0,2.88 0,3.6 L0,20.4 C0,21.12 0.6,21.6 1.2,21.6 L8.52,21.6 C7.68,20.16 7.2,18.48 7.2,16.8 C7.2,11.52 11.52,7.2 16.8,7.2 C19.08,7.2 21.12,8.04 22.8,9.36 L22.8,3.6 C22.8,3 22.2,2.4 21.6,2.4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,9.6 C12.84,9.6 9.6,12.84 9.6,16.8 C9.6,20.76 12.84,24 16.8,24 C20.76,24 24,20.76 24,16.8 C24,12.84 20.76,9.6 16.8,9.6 Z M19.2,18 L16.8,18 C16.08,18 15.6,17.52 15.6,16.8 L15.6,13.2 C15.6,12.48 16.08,12 16.8,12 C17.52,12 18,12.48 18,13.2 L18,15.6 L19.2,15.6 C19.92,15.6 20.4,16.08 20.4,16.8 C20.4,17.52 19.92,18 19.2,18 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCalendar);
export default __webpack_public_path__ + "static/media/grey-calendar.cf740b3ccb173870c796190b49f7d848.svg";
export { ForwardRef as ReactComponent };